import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-mid-page-white.component.scss';
import Slider from '../slider/slider.component';
var BannerMidPageWhite = /** @class */ (function (_super) {
    tslib_1.__extends(BannerMidPageWhite, _super);
    function BannerMidPageWhite(element) {
        return _super.call(this, element) || this;
    }
    BannerMidPageWhite.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    BannerMidPageWhite.prototype.bindEvents = function () { };
    return BannerMidPageWhite;
}(Base));
export { BannerMidPageWhite };



//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-white/banner-mid-page-white.component.ts
// module id = 141
// module chunks = 0